var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-taglist',_vm._l((_vm.tags),function(tag){return _c('tag-item',{key:tag.id,attrs:{"tag":tag}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }